import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngxs/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NewsState } from '../../states/news/news.state';
import { INewsItem } from '../../interfaces/news/INews';
import { NEWS_TYPES } from '../../enums/NewsTypes.enum';

@Component({
  selector: 'app-news',
  templateUrl: './app-news.component.html',
  styleUrl: './app-news.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class AppNewsComponent {
  private readonly store = inject(Store);
  private translateService = inject(TranslateService);
  protected readonly activeNews = this.store.selectSignal<INewsItem[]>(NewsState.activeNewsList);
  protected readonly NEWS_TYPES = NEWS_TYPES;

  protected formatDate(date: Date | string): string {
    return new Date(date).toLocaleDateString(this.translateService.getCurrentLang() === 'de' ? 'de-DE' : 'en-UK', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
